import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpaContext } from '../Classes/spacontext';
import { Helper } from '../Common/Helpers/helper';
import { ApplicationService } from '../Services/application.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
	constructor(
		public _spaContext: SpaContext,
		private helper: Helper,
		private applicationService: ApplicationService,
	) {}

	// biome-ignore lint/suspicious/noExplicitAny: Should refactor
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const defaultOptions = {
			'Content-Type': 'application/json', // Breaks fileupload
			'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			Pragma: 'no-cache',
			'X-App-WebVersion': this.applicationService.webVersion,
			'X-App-Lang': `${this._spaContext.languageCode}`,
			'X-XSRF-TOKEN': this.helper.cookie.get('XSRF-TOKEN') || '',
		};

		if (req.body instanceof FormData) {
			// Needed to auto generate corret content type
			delete defaultOptions['Content-Type'];
		}

		const setHeaders: { [key: string]: string } = {};
		Object.keys(defaultOptions).forEach((key) => {
			if (req.headers.has(key)) return;
			setHeaders[key] = defaultOptions[key];
		});

		const outReq = req.clone({
			setHeaders,
			withCredentials: true,
		});

		return next.handle(outReq);
	}
}
